import React from 'react';

const decodeHtmlEntities = (text) => {
  if (!text || typeof text !== 'string') return text;
  if (!text.includes('&')) return text;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

const GalleryBlockNav = ({ loaded, viewinfo, onBlockFlatChange }) => {
  const selBlock = viewinfo?.sel_block || [];
  const tableBlockFlat = viewinfo?.table_block_flat || [];
  const selectedBlockFlat = selBlock.find((option) => option.selected)?.value || '';

  if (!loaded || (selBlock.length === 0 && tableBlockFlat.length === 0)) {
    return null;
  }

  const handleBlockChange = (event) => {
    if (event.target.value && onBlockFlatChange) {
      onBlockFlatChange(event.target.value);
    }
  };

  const handleFlatClick = (cell) => {
    if (cell.has_photo && onBlockFlatChange) {
      onBlockFlatChange(cell.block_flat);
    }
  };

  return (
    <div className="gallery-block-nav">
      <div className="gallery-block-nav__label">座數</div>
      <select
        id="sel_block"
        name="sel_block"
        className="gallery-block-nav__select"
        value={selectedBlockFlat}
        onChange={handleBlockChange}
      >
        <option value="">請選擇座數</option>
        {selBlock.map((option) => (
          <option key={option.value} value={option.value}>
            {decodeHtmlEntities(option.label)}
          </option>
        ))}
      </select>

      <table className="gallery-unit-table">
        <tbody>
          <tr>
            <td className="gallery-unit-table__heading" colSpan={6}>
              單位
            </td>
          </tr>
          {tableBlockFlat.map((row, rowIndex) => (
            <tr key={`flat_row_${rowIndex}`}>
              {row.map((cell, cellIndex) => {
                const cellClass = cell.selected
                  ? 'gallery-unit-table__cell gallery-unit-table__cell--selected'
                  : cell.has_photo
                    ? 'gallery-unit-table__cell gallery-unit-table__cell--active'
                    : 'gallery-unit-table__cell';

                return (
                  <td
                    key={`flat_${rowIndex}_${cellIndex}`}
                    className={cellClass}
                    onClick={() => handleFlatClick(cell)}
                  >
                    {cell.has_photo ? (
                      <span className="gallery-unit-table__flat-link">{String(cell.flat).trim()}</span>
                    ) : (
                      '\u00a0'
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GalleryBlockNav;
